import { createSlice } from '@reduxjs/toolkit';
import { getConvertCurrency } from './actions';

const initialState = {
  data: {},
  isLoading: false,
  isError: false,
  errorMessage: {},
};

export const convertCurrency = createSlice({
  name: 'convertCurrency',
  initialState,
  reducers: {
    // reducers goes here
    resetConvertCurrency: (state) => {
      state.data = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getConvertCurrency.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.data = {};
      })
      .addCase(getConvertCurrency.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getConvertCurrency.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      });
  },
});

export const { resetConvertCurrency } = convertCurrency.actions;

export default convertCurrency.reducer;
